import { palette } from '../../styles/theme/index.js';
export const levels = [
    {
        id: 1,
        level: 'Diamante',
        styles: {
            backgroundColor: palette.diamond[100],
            color: palette.diamond[800],
            fontWeight: 700,
        },
        badgeStyles: {
            backgroundColor: palette.diamond[500],
            color: 'white',
            fontWeight: 700,
        }
    },
    {
        id: 2,
        level: 'Zafiro',
        styles: {
            backgroundColor: palette.sapphire[100],
            color: palette.sapphire[800],
            fontWeight: 700,
        },
        badgeStyles: {
            backgroundColor: palette.sapphire[500],
            color: 'white',
            fontWeight: 700,
        }
    },
    {
        id: 3,
        level: 'Oro',
        styles: {
            backgroundColor: palette.golden[100],
            color: palette.golden[800],
            fontWeight: 700,
        },
        badgeStyles: {
            backgroundColor: palette.golden[500],
            color: 'white',
            fontWeight: 700,
        }
    },
    {
        id: 4,
        level: 'Plata',
        styles: {
            backgroundColor: palette.silver[100],
            color: palette.silver[800],
            fontWeight: 700,
        },
        badgeStyles: {
            backgroundColor: palette.silver[500],
            color: 'white',
            fontWeight: 700,
        }
    },
    {
        id: 5,
        level: 'Bronce',
        styles: {
            backgroundColor: palette.bronze[100],
            color: palette.bronze[800],
            fontWeight: 700,
        },
        badgeStyles: {
            backgroundColor: palette.bronze[500],
            color: 'white',
            fontWeight: 700,
        }
    },
];
